import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X, Moon, Sun } from "lucide-react";
import { useTheme } from "next-themes";
import Logo from "./Logo";
import { useSite } from "../lib/site";

const NAV = [
  { to: "/", label: "Beranda", end: true },
  { to: "/tentang", label: "Tentang Saya" },
  { to: "/tulisan", label: "Tulisan" },
  { to: "/buku-karya", label: "Buku & Karya" },
  { to: "/konsultasi", label: "Konsultasi" },
  { to: "/kontak", label: "Kontak" },
];

export default function Header() {
  const { settings } = useSite();
  const [open, setOpen] = useState(false);
  const { resolvedTheme, setTheme } = useTheme();
  const [mounted, setMounted] = useState(false);
  const location = useLocation();

  useEffect(() => setMounted(true), []);
  useEffect(() => setOpen(false), [location.pathname]);

  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [open]);

  const navLink = (item, mobile = false) => (
    <NavLink
      key={item.to}
      to={item.to}
      end={item.end}
      data-testid={`nav-${item.to.replace("/", "") || "beranda"}${mobile ? "-mobile" : ""}`}
      className={({ isActive }) =>
        mobile
          ? `font-serif text-3xl py-3 border-b border-line flex items-center gap-3 ${isActive ? "text-ink" : "text-sub"}`
          : `relative text-[15px] font-medium transition-colors ${isActive ? "text-ink" : "text-sub hover:text-ink"}`
      }
    >
      {({ isActive }) => (
        <>
          {item.label}
          {isActive && <span className="inline-block w-1.5 h-1.5 rounded-full bg-enji ml-2" aria-hidden="true" />}
        </>
      )}
    </NavLink>
  );

  return (
    <>
      <header className="sticky top-0 z-40 bg-ivory/85 backdrop-blur border-b border-line">
        <div className="max-w-6xl mx-auto px-4 sm:px-8 h-16 flex items-center justify-between gap-4">
          <Logo />
          <nav className="hidden lg:flex items-center gap-7" aria-label="Navigasi utama">
            {NAV.map((item) => navLink(item))}
          </nav>
          <div className="flex items-center gap-2">
            <button
              data-testid="theme-toggle-button"
              aria-label={mounted && resolvedTheme === "dark" ? "Mode terang" : "Mode gelap"}
              onClick={() => setTheme(resolvedTheme === "dark" ? "light" : "dark")}
              className="w-11 h-11 rounded-full border border-line flex items-center justify-center text-sub hover:text-ink hover:border-sub transition-colors"
            >
              {mounted && resolvedTheme === "dark" ? <Sun size={17} /> : <Moon size={17} />}
            </button>
            <Link
              to="/newsletter"
              data-testid="header-newsletter-button"
              className="hidden sm:inline-flex btn-primary !min-h-[40px] !px-5"
            >
              {settings.newsletter_label || "Newsletter"}
            </Link>
            <button
              data-testid="mobile-menu-toggle"
              aria-label={open ? "Tutup menu" : "Buka menu"}
              aria-expanded={open}
              onClick={() => setOpen(!open)}
              className="lg:hidden w-11 h-11 rounded-full border border-line flex items-center justify-center text-ink"
            >
              {open ? <X size={20} /> : <Menu size={20} />}
            </button>
          </div>
        </div>
      </header>

      {open && (
        <div data-testid="mobile-menu" className="fixed inset-0 z-30 bg-ivory lg:hidden pt-24 px-6 pb-10 overflow-y-auto">
          <nav className="flex flex-col" aria-label="Navigasi seluler">
            {NAV.map((item) => navLink(item, true))}
          </nav>
          <Link to="/newsletter" data-testid="mobile-newsletter-button" className="btn-primary mt-8 w-full">
            {settings.newsletter_label || "Newsletter"}
          </Link>
        </div>
      )}
    </>
  );
}
